import { User } from '@supabase/supabase-js';
import { DataPlanCard } from './DataPlanCard';
import { ApiKeysCard } from './ApiKeysCard';

// SN Data on the account page: the plan (Free when there is none), then the API keys (30 Oct 2026).
export function DataTab({ user }: { user: User }) {
  return (
    <div className="space-y-4">
      <DataPlanCard user={user} />
      <ApiKeysCard user={user} />
    </div>
  );
}
